// extracted by mini-css-extract-plugin
export default {"activityTime":"activityTime__+DMmf","activityAction":"activityAction__sDemz","activityContainer":"activityContainer__QtePh"};